import { ReactElement } from 'react';
import { styled } from 'styled-components';
import SearchCondition from './search-condition/SearchCondition';
import Results from './results/Results';
import useRecordings from '../hooks/useRecordings';
import { blockStyle } from '../../../../components/styles/Block';
import layoutStyle from '../../../../components/styles/Layout';

const ContentBlock = styled.div`
  ${blockStyle}
`;

const ContentLayout = styled.div`
  ${layoutStyle}
  display: grid;
  grid-template-rows: auto 1fr;
  gap: 16px;
`;

const Content = (): ReactElement => {
  const { recordings, total, page, pageSize, filters, setPage, search } = useRecordings();

  return (
    <ContentBlock>
      <ContentLayout>
        <SearchCondition filters={filters} onSearch={search} />
        <Results recordings={recordings} page={page} pageSize={pageSize} total={total} onPageChange={setPage} />
      </ContentLayout>
    </ContentBlock>
  );
};

export default Content;
